import { get, del, postFd, put } from "@utils/axios";

const api = "designations";

export const getAllDesignations = (payload) => {
  return get(`${api}?page=${payload.page}&filters=${payload.filters}`)
};

export const createDesignationReq = (payload) => {
  return postFd(`${api}?`, payload);
};

export const updateDesignation = (payload) => {
  return put(`${api}/${payload.id}`, payload);
};

export const deleteDesignation = (id) => {
  return del(`${api}/${id}`);
};

export const getCompanyReq = () => {
  return get('common/getCompany')
}
export const getFilterReq = (payload) => {
  return get(`${api}?page=1&filters?company_id=1&fields=page=1&filters=organization_structure_fields_|company;preset_|designations;`)
}
